import { DocFile } from "./doc-file";
import {AchFundingSource} from "@app/shared/ach/org-payment-transaction";

export class OrgAchDetail {
  id?: number;
  version?: number;
  active?: boolean;
  nickName?: string;
  bankType?: string;
  bankName?: string;
  accountName?: string;
  accountType?: string;
  accountNumber?: string;
  routingNumber?: string;

  enableCheckPayment?: boolean;
  checkPaymentType?: string;
  payerAddressId?: number;
  useSignatureText?: boolean;
  signatureText?: string;
  signatureImage?: DocFile;
  achFundingSourceDetails?: AchFundingSource;
  achDefaultPaymentType?: AchDefaultPaymentType;
  orgId?: number;
  current?: boolean;

  constructor () {
    this.active = true;
  }
}

export enum AchDefaultPaymentType {
  Payroll = "PAYROLL",
  VendorPayable = "VENDOR_PAYABLE",
  All = "ALL",
}


